import { render, staticRenderFns } from "./design_description.vue?vue&type=template&id=1e42236e"
import script from "./design_description.vue?vue&type=script&lang=js"
export * from "./design_description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports